module.exports = __webpack_public_path__ + "img/loading-page-img.5e28714.svg";